/**
 * @generated SignedSource<<8a4ec76c15e89b9b070ac3b8831644a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddStreamTabModalMutation$variables = {
  otherStreamId: string;
  share?: boolean | null;
  streamId: string;
};
export type AddStreamTabModalMutation$data = {
  readonly StreamTab_AddFellowNotesTab: {
    readonly stream: {
      readonly id: string;
      readonly tabs: ReadonlyArray<{
        readonly icon: string | null;
        readonly id: string;
        readonly isEmbedded: boolean;
        readonly order: number;
        readonly otherStreamId: string | null;
        readonly title: string;
        readonly url: string | null;
      }>;
    };
  } | null;
};
export type AddStreamTabModalMutation = {
  response: AddStreamTabModalMutation$data;
  variables: AddStreamTabModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherStreamId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "share"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "otherStreamId",
        "variableName": "otherStreamId"
      },
      {
        "kind": "Variable",
        "name": "share",
        "variableName": "share"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      }
    ],
    "concreteType": "AddFellowStreamTab",
    "kind": "LinkedField",
    "name": "StreamTab_AddFellowNotesTab",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamTabNode",
            "kind": "LinkedField",
            "name": "tabs",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherStreamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEmbedded",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddStreamTabModalMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddStreamTabModalMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "7560b72d0a194aa164feab2a9ae6d210",
    "id": null,
    "metadata": {},
    "name": "AddStreamTabModalMutation",
    "operationKind": "mutation",
    "text": "mutation AddStreamTabModalMutation(\n  $streamId: ID!\n  $otherStreamId: ID!\n  $share: Boolean\n) {\n  StreamTab_AddFellowNotesTab(streamId: $streamId, otherStreamId: $otherStreamId, share: $share) {\n    stream {\n      id\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "65af8244ca121f85e28a957a12e1431c";

export default node;
